/**
 * Player Icons Configuration
 * Maps player roles to their helmet icon images
 */

export const PLAYER_ICONS: Record<string, string> = {
  Biologist: '/icons/biologist.png',
  Diver: '/icons/diver.png',
  Fixer: '/icons/fixer.png',
  Historian: '/icons/historian.png',
  Hunter: '/icons/hunter.png',
};

/**
 * Character/NPC Icons Configuration
 * Maps character voices to their icon images
 */
export const CHARACTER_ICONS: Record<string, string> = {
  MOTHERSHIP: '/icons/MOTHERSHIP.png',
  GEE: '/icons/GEE.png',
  DOC: '/icons/doc.png',
  NARRATOR: '/icons/centauri-logo.png', // Use logo for narrator
};

/**
 * Get the icon URL for a character voice
 */
export function getCharacterIcon(voice: string): string | null {
  return CHARACTER_ICONS[voice.toUpperCase()] || null;
}

/**
 * Get the icon URL for a specific role
 */
export function getPlayerIcon(role: string): string | null {
  return PLAYER_ICONS[role] || null;
}

/**
 * Get all available player icons
 */
export function getAllPlayerIcons(): Record<string, string> {
  return PLAYER_ICONS;
}
